<template>
    <a
        v-if="isAuth"
        :href="$getSubdomainLink('portal', '/home')"
        class="navbar__logo"
    >
        <img src="@/assets/images/logo.svg" :alt="appName" class="d-none d-lg-block"/>
        <img src="@/assets/images/logo-mobile.svg" :alt="appName" class="d-lg-none"/>
    </a>
    <a v-else :href="$getSubdomainLink('', '/')" class="navbar__logo">
        <img src="@/assets/images/logo.svg" :alt="appName" class="d-none d-lg-block" />
        <img src="@/assets/images/logo-mobile.svg" :alt="appName" class="d-lg-none"/>
    </a>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
    data() {
        return {
            authStore: useAuthStore(),
            appName: import.meta.env.VITE_APPNAME,
        };
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>
